<template>
  <d2-container>
   <div class="supports">
      <div class="supportcontent">
        <div class="supportcontcard">
          <h4 class="supportcontcardTitle">联系我们</h4>
          <div class="supportcontcardMsg">
            <p>根据您点击的产品详情在您表单提交后，会有工作人员第一时间与您电话联系</p>
            <p>如果您现在就需要帮助，可立即拨打 <span>17858952922</span> 与我们联系!</p>
          </div>
          <el-form :model="form" status-icon :rules="rules" ref="form" label-width="160px" class="demo-ruleForm">
            <el-form-item label="算力资源id" prop="power_id" v-show="false">
              <el-input v-model="form.power_id" placeholder="请输入您的称呼" v-show="false"></el-input>
            </el-form-item>
            <el-form-item label="称呼" prop="name" >
              <el-input v-model="form.name" placeholder="请输入您的称呼" clearable></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入您的电话" clearable></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" >
              <el-input v-model="form.email" placeholder="请输入您的邮箱地址" clearable></el-input>
            </el-form-item>
            <el-form-item label="单位" prop="corp">
              <el-input v-model="form.corp" placeholder="请输入您的单位名称"></el-input>
            </el-form-item>
            <el-form-item label="行业" prop="industry">
              <el-input v-model="form.industry" placeholder="请输入您的行业"></el-input>
            </el-form-item>
            <el-form-item label="需求描述" prop="demand">
              <el-input type="textarea" :rows="5" v-model="form.demand"></el-input>
            </el-form-item>
            <div id="captcha-element" style="height: 0;"></div>
            <el-form-item >
              <el-button type="primary" class="login-btn" id="submit-btn" :disabled="canClickSubmit" @click="doSubmit" style="width: 125px; color:#fff;" >提交</el-button>
            </el-form-item>
          </el-form>
          </div>
      </div>

      <base-bottom></base-bottom>
   </div>
  </d2-container>
</template>
<script>
import baseBottom from '../components/base-bottom';
import { addNewList } from "@/api/data.js";

export default {
  name: 'hosting',
  components: {
    baseBottom
  },
  data() {
    return {
      captchaInstance: null,
      form: {
        power_id: '',
        name: '',
        phone: '',
        email: '',
        corp: '',
        industry: '',
        authcode: '',
        demand: '',
        captchaToken: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的称呼', trigger: 'blur' },
          { min: 2, max: 20, message: '称呼长度应在2到20个字符之间', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入您的电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入有效的电话号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入您的邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入有效的邮箱地址', trigger: 'blur' }
        ],
      }
    };
  },
  created() {
    this.form.power_id = this.$route.query.power_id || '';
  },
  mounted() {
    // 初始化阿里云验证码
    initAliyunCaptcha({
      SceneId: '18fd1xsb', // 场景ID。通过步骤一添加验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      prefix: '1g25jr', // 身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
      mode: 'popup', // 验证码模式。embed表示要集成的验证码模式为嵌入式。无需修改
      element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: '#submit-btn', // 触发业务请求的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      captchaVerifyCallback: this.captchaVerifyCallback, // 业务请求(带验证码校验)回调函数
      onBizResultCallback: this.onBizResultCallback, // 业务请求结果回调函数
      getInstance: this.getInstance, // 绑定验证码实例函数
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      immediate: false, // 完成验证后，是否立即发送验证请求（调用captchaVerifyCallback函数）
      region: 'cn' //验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
    });
  },
  computed: {
    canClickSubmit () {
      return !(this.form.name && this.form.phone && this.form.email && this.isValidPhone(this.form.phone) && this.isValidEmail(this.form.email))
    }
  },
  methods: {
    /******************************************************************************************/
    // 阿里云captchar验证（验证真人操作）相关
    async captchaVerifyCallback (captchaVerifyParam) {
      // console.log('# captchaVerifyCallback - entry', captchaVerifyParam)
      console.log('# captchaVerifyCallback - entry')
      // this.bSentCodeSuccess = false
      console.log(this.form)
      if (!this.form.name) {
        this.$message.error({
          message: '请输入您的称呼',
          center: true // 居中显示
        })
        this.$refs.name.focus()
        return
      }
      if (!this.form.phone) {
        this.$message.error({
          message: '请输入手机号',
          center: true // 居中显示
        })
        this.$refs.phone.focus()
        return
      }
      if (!this.form.email) {
        this.$message.error({
          message: '请输入您的电子邮箱地址',
          center: true // 居中显示
        })
        this.$refs.email.focus()
        return
      }

      const response = await this.$axios.post('/api/captcha', {captchaVerifyParam: captchaVerifyParam})
      console.log(response)
      if (response.data && response.code === 200) {
        this.captchaVerifyResult = response.data.captchaVerifyResult
      } else {
        this.$message.error({
          message: response.msg,
          center: true // 居中显示
        })
      }

      return {
        captchaResult: this.captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
        bizResult: true, // 业务验证是否通过，boolean类型，可选，若为无业务验证结果的场景，bizResult可以为空
      }
    },

    async onBizResultCallback (bizResult) {
      console.log('# onBizResultCallback - entry', this.captchaVerifyResult, bizResult)
      await this.doSubmit()
      console.log('# onBizResultCallback - return')
    },

    getInstance (instance) {
      console.log('# getInstance - return', instance)
    },

    async doSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.captchaVerifyResult) {
            this.$message.error('未通过操作验证，请刷新网页再试一次。');
            return false;
          }
          this.submitForm();
        } else {
          this.$message.error('请检查表单内容');
          return false;
        }
      });
    },
    submitForm() {
      this.$axios.post('/api/power_contact_us', this.form)
        .then(resp => {
          if (resp.code === 200) {
            this.$message.success(resp.msg || '提交成功');
            this.$router.push('/successMsg');
          } else {
            this.$message.error(resp.msg || '提交失败，请稍后重试');
          }
        })
        .catch(error => {
          this.$message.error('网络错误，请稍后重试');
          console.error('提交失败:', error);
        });
    },
    isValidPhone(phone) {
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(phone)
    },
    isValidEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      return emailRegex.test(email)
    }
  }
};
</script>


<style scoped>
@media (min-width: 769px) {
    /* PC端样式 */
.supports{
  min-height: 100vh;
}
.supportcontent{
  /* background: url(/image/portalimg/support/card.png) no-repeat center center; */
  width: 1560px;
  margin: 50px auto 200px;
}
.supportcontcard{
  width: 800px;
  margin: 0 auto;
}
.supportcontcardMsg {
  font-size: 18px;
  color: #333;
  letter-spacing: 2px;
  text-align: left;
  font-weight: 400;
  padding: 0 58px 40px;
  margin: 0;
}
.supportcontcardMsg p span{
  color: #409EFF;
}
.supportcontcardTitle{
  font-size: 38px;
  color: #000000;
  letter-spacing: 4px;
  text-align: left;
  font-weight: 400;
  padding: 80px 58px 40px;
  margin: 0;
}

.el-form-item{
  margin-bottom: 30px !important;
}

::v-deep .el-form-item__label {
    font-size: 18px !important; /* 根据需要调整 */
    padding-right: 50px;
    line-height: 52px;
}

::v-deep .el-input__inner {
    height: 50px; /* 调整高度 */
    line-height: 50px; /* 保证文本垂直居中 */
    font-size: 14px; /* 调整字体大小 */
}
::v-deep .item__error{
  top:58px;
}
.login-btn span{
  color:#fff !important;
}
.el-textarea{
  margin-top: 0px !important;
}

#c aptcha-element {
  width: 360px;
  height: 40px;
  margin-top: 10px;
}
#submit-btn{
  color: #fff !important;
}
#submit-btn span{
  color: #fff !important;
}


}

@media (max-width: 768px) {
    /* 移动端样式 */
  .supports{
  width: 100%;
  min-height: 100vh;
}
.supportcontent{
  /* background: url(/image/portalimg/support/card.png) no-repeat center center; */
  width: 100%;
  margin: 50px auto 100px;
}
.supportcontcard{
    width: 100%;
}
.supportcontcardMsg {
  font-size: 12px;
  color: #333;
  letter-spacing: 0px;
  text-align: left;
  font-weight: 400;
  padding: 0 0 20px 7%;
  margin: 0;
}
.supportcontcardMsg p{
  margin: 8px 0;
}
.supportcontcardMsg p span{
  color: #409EFF;
}
.supportcontcardTitle{
  text-align: left;
  font-size: 20px;
  color: #000;
  letter-spacing: 2px;
  font-weight: 400;
  margin: 0;
  padding: 20px 7% 12px;
  font-weight: bold;
}

.demo-ruleForm{
  margin:0 5%;
}
#submit-btn{
    color: #fff !important;
  }
  #submit-btn span{
    color: #fff !important;
  }
  
}
</style>
